export const RESET_PROJECT_IDENTIFICATION_LIST =
  'project_identification/RESET_PROJECT_IDENTIFICATION_LIST';

export const LOAD_PROJECT_IDENTIFICATION_LIST =
  'project_identification/LOAD_PROJECT_IDENTIFICATION_LIST';
export const LOAD_PROJECT_IDENTIFICATION_LIST_SUCCESS =
  'project_identification/LOAD_PROJECT_IDENTIFICATION_LIST_SUCCESS';
export const LOAD_PROJECT_IDENTIFICATION_LIST_ERROR =
  'project_identification/LOAD_PROJECT_IDENTIFICATION_LIST_ERROR';

export const LOAD_PROJECT_IDENTIFICATION_DETAIL =
  'project_identification/LOAD_PROJECT_IDENTIFICATION_DETAIL';
export const LOAD_PROJECT_IDENTIFICATION_DETAIL_SUCCESS =
  'project_identification/LOAD_PROJECT_IDENTIFICATION_DETAIL_SUCCESS';
export const LOAD_PROJECT_IDENTIFICATION_DETAIL_ERROR =
  'project_identification/LOAD_PROJECT_IDENTIFICATION_DETAIL_ERROR';

export const CREATE_PROJECT_IDENTIFICATION =
  'project_identification/CREATE_PROJECT_IDENTIFICATION';
export const CREATE_PROJECT_IDENTIFICATION_SUCCESS =
  'project_identification/CREATE_PROJECT_IDENTIFICATION_SUCCESS';
export const CREATE_PROJECT_IDENTIFICATION_ERROR =
  'project_identification/CREATE_PROJECT_IDENTIFICATION_ERROR';

export const UPDATE_PROJECT_IDENTIFICATION =
  'project_identification/UPDATE_PROJECT_IDENTIFICATION';
export const UPDATE_PROJECT_IDENTIFICATION_SUCCESS =
  'project_identification/UPDATE_PROJECT_IDENTIFICATION_SUCCESS';
export const UPDATE_PROJECT_IDENTIFICATION_ERROR =
  'project_identification/UPDATE_PROJECT_IDENTIFICATION_ERROR';
